import type { SVGProps } from 'react';

const PencilIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 16.4963L18.4999 17.5904C17.9695 18.1705 17.2501 18.4963 16.5001 18.4963C15.7501 18.4963 15.0308 18.1705 14.5004 17.5904C13.9692 17.0114 13.25 16.6864 12.5002 16.6864C11.7504 16.6864 11.0311 17.0114 10.5 17.5904M1.5 18.4963H3.17454C3.66372 18.4963 3.90832 18.4963 4.13849 18.4411C4.34256 18.3921 4.53765 18.3113 4.7166 18.2016C4.91843 18.0779 5.09138 17.905 5.43729 17.5591L18 4.99632C18.8285 4.16789 18.8285 2.82475 18 1.99632C17.1716 1.16789 15.8285 1.16789 15 1.99632L2.43726 14.5591C2.09136 14.905 1.9184 15.0779 1.79472 15.2797C1.68506 15.4587 1.60425 15.6538 1.55526 15.8579C1.5 16.088 1.5 16.3326 1.5 16.8218V18.4963Z"
      stroke="#384250"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PencilIcon;
